import React, { useEffect } from 'react';
import DetailedInformationComponent from './DetailedInformationComponent';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { getModel } from './selectors';
import * as actions from './actions';
import { setIsDefaultLimitsSelected } from './OperationalParametersV2/SingleChartView/Trend/LimitSelector/actions';

import './style.scss';
import { setSelectedNotification } from '../../PowertrainOverview/Header/NotificationDropdown/actions';
import { triggerReportIssueDialog } from '../../PowertrainOverview/actions';

const DetailedInformationContainer = (props) => {

    useEffect(() => {
        return () => {
            props.actions.clearStore();
            if (props.model?.selectedNotification) {
                props.actions.setSelectedNotification(null);
            }
        };
    }, []);

    return <LoadingStatusWrapper
        loadingStatus={
            props.model.generalFilterLoadingStatuses.organizationsLoadingStatus
        }>
        <DetailedInformationComponent {...props} />
    </LoadingStatusWrapper>;
};


const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ ...actions, setIsDefaultLimitsSelected, setSelectedNotification, triggerReportIssueDialog }, dispatch)
    };
};

const DetailedInformationContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(DetailedInformationContainer);

DetailedInformationContainer.propTypes = {
    model: PropTypes.shape({
        generalFilterLoadingStatuses: PropTypes.shape({
            organizationsLoadingStatus: PropTypes.string.isRequired // Loading status for organizations
        }).isRequired,
        selectedNotification: PropTypes.object // Selected notification object
    }).isRequired,
    actions: PropTypes.shape({
        clearStore: PropTypes.func.isRequired, // Action to clear the store
        setSelectedNotification: PropTypes.func.isRequired, // Action to set the selected notification
        setIsDefaultLimitsSelected: PropTypes.func.isRequired // Action to set default limits
    }).isRequired
};

export default DetailedInformationContainerConn;
